import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowLeft,
  faArrowRight,
  faChartLine,
  faClipboardCheck,
  faComments,
  faGraduationCap,
  faPeopleGroup,
  faRocket,
} from "@fortawesome/free-solid-svg-icons";
import images from "./loadImages";
import SiteHeader from "./SiteHeader";
import SiteFooter from "./SiteFooter";
import "../assets/css/ModernPages.css";

const services = [
  {
    icon: faPeopleGroup,
    number: "01",
    title: "Recruitment",
    text: "End-to-end hiring support that brings capable people into roles where they can make a measurable difference.",
  },
  {
    icon: faRocket,
    number: "02",
    title: "Executive search",
    text: "Discreet, insight-led search for the senior people who shape direction, culture, and growth.",
  },
  {
    icon: faChartLine,
    number: "03",
    title: "Flexible staffing",
    text: "Temporary, contract, and permanent workforce solutions that move at the pace of your business.",
  },
  {
    icon: faClipboardCheck,
    number: "04",
    title: "Assessment",
    text: "Structured evaluation of skills, strengths, and fit so every shortlist is built on more than a CV.",
  },
  {
    icon: faComments,
    number: "05",
    title: "HR consulting",
    text: "Practical guidance to improve your talent strategy, people processes, and everyday hiring decisions.",
  },
  {
    icon: faGraduationCap,
    number: "06",
    title: "Training",
    text: "Targeted learning programs that help teams grow capability, confidence, and long-term performance.",
  },
];

const capabilityGroups = [
  [
    "Technical & engineering",
    "Engineers, planning, design, production, quality",
  ],
  ["Technology & operations", "MIS, computer operations, SEO, logistics"],
  ["Business & support", "Accounts, sales, marketing, administration"],
  [
    "Safety & environment",
    "Safety supervisors, fire officers, environmental roles",
  ],
];

const ServicesPage = () => (
  <main className="modern_page inner_page services_page">
    <SiteHeader activePage="services" />

    <section className="inner_hero shell">
      <Link to="/" className="back_link">
        <FontAwesomeIcon icon={faArrowLeft} /> Back to home
      </Link>
      <p className="eyebrow">
        <span /> Our services
      </p>
      <h1>
        Good hiring is a<br />
        <em>growth strategy.</em>
      </h1>
      <p className="inner_lede">
        From your first brief to the right person joining the team, we make
        every step clearer, quicker, and more considered.
      </p>
    </section>

    <section className="service_grid shell">
      {services.map((service) => (
        <article className="service_card" key={service.number}>
          <div className="service_card_top">
            <span>{service.number}</span>
            <FontAwesomeIcon icon={service.icon} />
          </div>
          <h2>{service.title}</h2>
          <p>{service.text}</p>
          <Link to="/contact">
            Discuss this service <FontAwesomeIcon icon={faArrowRight} />
          </Link>
        </article>
      ))}
    </section>

    <section className="capabilities shell">
      <div className="capability_intro">
        <p className="eyebrow">
          <span /> Our reach
        </p>
        <h2>
          Talent for the work
          <br />
          <em>ahead.</em>
        </h2>
        <p>
          We connect organizations with people across the disciplines that keep
          modern businesses moving.
        </p>
      </div>
      <div className="capability_list">
        {capabilityGroups.map(([title, description], index) => (
          <div className="capability_row" key={title}>
            <span>0{index + 1}</span>
            <div>
              <h3>{title}</h3>
              <p>{description}</p>
            </div>
            <img
              src={
                images[
                  [
                    "Engineering and Technical Experts.png",
                    "Information Technology Specialists.png",
                    "Non-Technical Professionals.png",
                    "Safety and Environmental Professionals.png",
                  ][index]
                ]
              }
              alt=""
            />
          </div>
        ))}
      </div>
    </section>

    <section className="service_cta shell">
      <div>
        <p className="eyebrow">
          <span /> Let’s make a match
        </p>
        <h2>
          Have a role to fill
          <br />
          <em>or a move to make?</em>
        </h2>
      </div>
      <Link to="/contact" className="primary_action">
        Talk to Staffing Mart <FontAwesomeIcon icon={faArrowRight} />
      </Link>
    </section>
    <SiteFooter />
  </main>
);

export default ServicesPage;
